import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

import { PagoService } from 'services/PagoService';
import useRequest from 'hooks/useRequest';
import { useStore } from "store/context";

import GradientButton from 'components/atoms/GradientButton';
import MainLayout from 'components/Layouts/MainLayout';

import Modal from 'components/atoms/Modal';

import './styles.scss';

const PagoExitosoView = (props) => {
    const history = useHistory();

    const {
        success, message,
        beforeSubmit, afterSubmit,
        dealWithError
    } = useRequest();

    const [{
        uf,  // La uf actual seleccionada
    }, dispatch] = useStore();

    const { id, external_reference } = useParams();

    const titleDebito = <>
        <strong>UF</strong> {uf.unidad} - {uf.alias}
    </>;

    const [showMetodoPago, setShowMetodoPago] = useState(false);

    const handleCloseMetodoPago = () => {
        setShowMetodoPago(false);
        history.push('/consulta_descarga_facturas');
    }

    const bodyMetodoPago = <span className="confirmar-baja-body">
        <h3>MÉTODO DE PAGO</h3>
        <div className="confirmar-baja-container">
            <div className="confirmar-baja-content baja-confirmar">

                {(success === false && message) &&
                    <p className="confirmar-baja-mensaje">{message}</p>
                }

                <div className="confirmar-baja-button">
                    <GradientButton legend={'CERRAR'} handleClick={handleCloseMetodoPago} />
                </div>
            </div>
        </div>
    </span>;

    useEffect(() => {
        console.log('Pago exitoso');
        console.log(id);
        console.log(external_reference);
        beforeSubmit();
        PagoService.pagoExitoso(id, external_reference)
            .then(data => {
                afterSubmit();
                console.log(data);
                console.log(success);
            }).catch((error) => {
                console.log('Error al marcar pago exitoso');
                setShowMetodoPago(true);
                dealWithError(error, '');
            });
    }, []);

    const consultaYDescarga = (e) => {
        e.preventDefault();

        history.push('/consulta_descarga_facturas');
    };

    return (<>
        <MainLayout>
            {success !== false && <h1>Pago exitoso</h1>}
            <div className="metodos-pagos-volver">
                <GradientButton legend={'VOLVER'} handleClick={consultaYDescarga} />
            </div>
            <div className="metodos-pagos-boxes">
                {success !== false &&
                    <h2>El pago se ha realizado exitosamente</h2>
                }
            </div>
        </MainLayout>
        <Modal className="modal-debito-automatico" title={titleDebito} body={bodyMetodoPago} legend={""} handleClose={handleCloseMetodoPago} show={showMetodoPago}></Modal>
    </>
    );
}

export default withTranslation()(PagoExitosoView);